import { ApplicationData } from "../applicationData";
function getVortexPath(id) {
    const vortexPaths = ApplicationData.instance.paths;
    return vortexPaths[id];
}
export default getVortexPath;
